import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback } from 'preact/compat';
import { useController, useFormContext, } from 'react-hook-form';
import { clsx } from 'clsx';
import FormGroup from '@enquiryForm/components/FormGroup';
import FormLabel from '@enquiryForm/components/FormLabel';
import FormError from '@enquiryForm/components/FormError';
import { useMemo } from 'react';
function VoucherInput(props) {
    const { inputAttrs, labelAttrs } = props;
    const { name, className: forwardedInputClasses } = inputAttrs;
    const { control, setValue, formState: { isSubmitted } } = useFormContext();
    const { field: { value }, fieldState: { invalid, isTouched, error }, } = useController({ name, control });
    const className = clsx('form__control', forwardedInputClasses, { invalid: invalid && (isTouched || isSubmitted) });
    const handleInputChange = useCallback((ev) => {
        const formattedValue = ev.currentTarget.value.toUpperCase();
        setValue(name, formattedValue, { shouldTouch: true, shouldValidate: true });
    }, [name, setValue]);
    const formattedInputs = useMemo(() => ({
        ...inputAttrs,
        minLength: 12,
        maxLength: 12,
    }), [inputAttrs]);
    return (_jsxs(FormGroup, { className: error ? 'form__group--error' : '', children: [_jsx(FormLabel, { ...labelAttrs }), _jsx("input", { ...formattedInputs, onChange: handleInputChange, value: value, className: className }), (error && (isTouched || isSubmitted)) && (_jsx(FormError, { children: error?.message }))] }));
}
export default VoucherInput;
